module.exports = __webpack_public_path__ + "static/media/homelab.eeb32943.jpg";